import { green, grey } from '@mui/material/colors';
import { PaletteOptions } from '@mui/material/styles/createPalette';

const customBlue = {
  50: '#e9f0fb',
  100: '#c8daf4',
  200: '#a3c1ed',
  300: '#7ea8e5',
  400: '#6395e0',
  500: '#4782da',
  600: '#407ad6',
  700: '#376fd0',
  800: '#2f65cb',
  900: '#2052c2',
};

const defaultVariant = {
  name: 'default',
  palette: {
    mode: 'light',
    primary: {
      main: '#4941e0',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#58579b',
      contrastText: '#FFF',
    },
    background: {
      default: '#edf2f9',
      paper: '#FFF',
    },
  } as PaletteOptions,
  header: {
    color: grey[500],
    background: '#FFF',
    search: {
      color: grey[800],
    },
    indicator: {
      background: customBlue[600],
    },
  },
  footer: {
    color: grey[500],
    background: '#FFF',
  },
  sidebar: {
    color: '#cbd5e1',
    background: '#0f172a',
    header: {
      color: '#cbd5e1',
      background: '#0f172a',
      brand: {
        color: customBlue[500],
      },
    },
    footer: {
      color: grey[200],
      background: '#1E2A38',
      online: {
        background: green[500],
      },
    },
    badge: {
      color: '#FFF',
      background: customBlue[500],
    },
  },
};

export default defaultVariant;
